import { useTranslation } from "react-i18next";
import React from "react";
import LanguageSwitcher from "./LanguageSwitcher";
import { Link } from "react-router-dom";
import logo from "../assets/img/logos/color-logos/syncorb_ai_and_text_logo.png";

const Navbar = () => {
  const { t } = useTranslation();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img 
            src={logo} 
            alt="SyncOrb-AI" 
            className="navbar-logo d-inline-block align-top"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown">
              <button 
                id="nav-services" 
                className="nav-link dropdown-toggle btn btn-link" 
                type="button"
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}
              >
                <span style={{ marginRight: '6px' }}>⚡</span>
                {t('navbar.services')}
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <Link className="dropdown-item" to="/#services">
                    <span style={{ marginRight: '8px', fontSize: '16px' }}>🔧</span>
                    {t('navbar.dropdown.apiServices')}
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/mobile-apps">
                    <span style={{ marginRight: '8px', fontSize: '16px' }}>📱</span>
                    {t('navbar.dropdown.mobileApps')}
                  </Link>
                </li>
                <li>
                  <a 
                    className="dropdown-item" 
                    href="https://docugenius.online:8443/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span style={{ marginRight: '8px', fontSize: '16px' }}>🌐</span>
                    {t('navbar.dropdown.webApps')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link id="nav-features" className="nav-link" to="/#features">{t('navbar.features')}</Link>
            </li>
            <li className="nav-item">
              <Link id="nav-pricing" className="nav-link" to="/#pricing">{t('navbar.pricing')}</Link>
            </li>
            <li className="nav-item">
              <Link id="nav-aboutus" className="nav-link" to="/about-us">{t('navbar.aboutus')}</Link>
            </li>
            <li className="nav-item">
              <Link id="nav-contact" className="nav-link" to="/contact-us">{t('navbar.contact')}</Link>
            </li>
            <li className="nav-item">
              <Link id="nav-signin" className="nav-link" to="/sign-in">{t('navbar.signin')}</Link>
            </li>
            <li className="nav-item">
              <Link id="nav-demo" className="btn btn-primary" to="/contact-us">{t('navbar.demo')}</Link>
            </li>
            <li className="nav-item">
              <LanguageSwitcher />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
